import { createClient } from "@supabase/supabase-js";

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnon = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnon, {
  auth: {
    autoRefreshToken:  true,
    persistSession:    true,
    detectSessionInUrl: true,
    storageKey: "sb-njnv-auth-token",
    // The navigator.locks API deadlocks in CRA dev mode (multiple HMR reloads
    // leave orphaned locks). Bypass it with a no-op — safe for single-tab apps.
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});
